import React, { useState, useEffect } from "react";
import { CardBody, Card, Row, Col } from 'reactstrap';
import { PayrollClient } from "services";
import {Trans} from "react-i18next";
import { NotificationManager } from "react-notifications";
import BackButton from "components/refactoring/BackButton";
import MainForm from "./shiftform"

const Edit = ({t, match}) => {

  const payrollClient = PayrollClient();

  const shiftId  = match.params.id;


  var intial_state = {
    name: "",
    time_from: "",
    time_to: "",
    time_from2: null,
    time_to2: null,
    date_from: "",
    date_to: "",
    permanent:false,
  }

  const [ shiftForm, setShiftForm ] = useState(intial_state)
 
  const saveItem = (validateForm, form_) => {

    const errors = validateForm(form_);
    
    if(errors.length > 0){
        NotificationManager.error(errors[0]);
        return;
    }
    const shiftFormHolder = shiftForm //Object.entries(shiftForm).reduce((a,[k,v]) => (v ? (a[k]=v, a) : a), {})
    payrollClient
    .put(`shifts/${shiftId}`, {
      ...shiftFormHolder
    })
    .then(({ data }) => {
      NotificationManager.success(t("Saved successfully"));

    })
    .catch((err) => {
      NotificationManager.error(t('Error while saving shift'));
    });
  }

  useEffect(() => {
    payrollClient
    .get(`shifts/${shiftId}`)
    .then(({ data }) => {
      console.log(data)
      setShiftForm(data)

    })
    .catch((err) => {
      NotificationManager.error(t('Error while getting shift'));
    });

  }, [])
  return (
    <div className="settingsmanagement">
      <Row>
        <Col xs="12" md="12" sm="12">
          <Card>
            <CardBody>
              <BackButton/>
              <h4 className="mt-2 mb-4"><Trans>Update Shift</Trans></h4>
              
              {/* <Form className="form mt-3"> */}
              <MainForm  shiftForm={shiftForm} setShiftForm={setShiftForm} type="Update" action={saveItem} t={t} />
              {/* </Form> */}

              <hr />

            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
};

export default Edit;


